import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import Translate from 'translate';
import moment from 'moment';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
class CollectionModal extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open, dateFormat, externalCustomer } = this.props;

    return (
      <Modal little
             modalClassName="col-md-4 client-folder p-0"
             open={open}
             onClose={onClose}>
        <div className="bg-blue p-3 mb-4">
          <h5 className="m-0 d-inline-block"><Translate id="payment"/> {_.get( data, 'DocNumber' )}</h5>
        </div>

        <div className="px-3">
          <div className="row mb-4">
            <div className="col-md">
              <p className="mb-1"><Translate id="collectionCenter"/>: {_.get( data, 'CollCenter', '-' )}</p>
              {externalCustomer === 'apu' (
              <p className="m-0"><Translate id="processedDate"/>: { dateFormat }</p>
              )}
              {externalCustomer !== 'apu' (
              <p className="m-0"><Translate id="processedDate"/>: {moment.unix( _.get( data, 'ProcessedDate', '-' ) ).format( dateFormat ) }</p>
              )}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCustomer: state.settings.externalCustomer,

} );
export default injectIntl( connect( mapStateToProps )( CollectionModal ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/CollectionModal/index.js